<ng-container *ngIf="showStepsWidget">
  <app-application-steps
    *ngIf="applicationTypeText !== 'installation-data.ccd-drr'"
    [showTechnicalFormFirst]="true"
    [currentStep]="step"
    [isDetailsView]="isDetailsView"></app-application-steps>
  <app-consumption-device-steps
    *ngIf="applicationTypeText === 'installation-data.ccd-drr'"
    [currentStep]="ApplicationStepType.PersonalData"></app-consumption-device-steps>
</ng-container>

<div class="personal-data-container component-container" id="print-form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align" *ngIf="showPageHeader">
    <app-application-header
      [title]="applicationTypeText | translate"
      [applicationExternalId]="externalApplicationId"></app-application-header>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'personal-data.title' | translate }}
    </div>
  </div>

  <ng-container *ngIf="!isLoading">
    <form #personalDataForm="ngForm" class="form-section form-font-size">
      <!-- CONNECTION ADDRESS -->
      <app-review-section
        #connectionAddressSection
        [title]="'personal-data.form-details.connection-address-title' | translate"
        [tooltip]="'tooltips.personal-data.connection-address' | translate"
        [sectionId]="SectionIdentifier.PersonalData_ConnectionAddress"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div
          class="personal-data-container"
          *ngIf="connectionAddressData"
          [ngClass]="personalDataSectionsState?.is_connection_address_locked !== true || !isDetailsView ? '' : 'disable-section'">
          <div class="component-container" *ngIf="!useAreaLocation">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'personal-data.form-details.fields.post-code' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  pInputText
                  size="30"
                  [(ngModel)]="connectionAddressData.postcode"
                  name="postCode"
                  #postCode="ngModel"
                  required
                  [disabled]="disableConnectionAddressPredefinedFields" />
              </div>

              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'personal-data.form-details.fields.city-ort' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  maxlength="100"
                  pInputText
                  size="30"
                  [(ngModel)]="connectionAddressData.city"
                  name="city"
                  #city="ngModel"
                  required
                  [disabled]="disableConnectionAddressPredefinedFields" />
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"></div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'personal-data.form-details.fields.district' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  maxlength="50"
                  pInputText
                  size="30"
                  [(ngModel)]="connectionAddressData.district"
                  name="district"
                  #district="ngModel"
                  [disabled]="disableConnectionAddressPredefinedFields" />
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'personal-data.form-details.fields.street' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  maxlength="30"
                  pInputText
                  size="30"
                  [(ngModel)]="connectionAddressData.street"
                  name="street"
                  #street="ngModel"
                  required
                  [disabled]="disableConnectionAddressPredefinedFields" />
              </div>

              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'personal-data.form-details.fields.street-number' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  maxlength="10"
                  pInputText
                  size="30"
                  [(ngModel)]="connectionAddressData.street_no"
                  name="streetNumber"
                  #streetNumber="ngModel"
                  required
                  [disabled]="disableConnectionAddressPredefinedFields" />
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"></div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'personal-data.form-details.fields.address-suffix' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  maxlength="50"
                  pInputText
                  size="30"
                  [(ngModel)]="connectionAddressData.address_suffix"
                  name="addressSuffix"
                  #addressSuffix="ngModel"
                  [disabled]="!connectionAddressSection.isDataEditable" />
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"></div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'personal-data.form-details.fields.apartment-number' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  pInputText
                  maxlength="30"
                  size="30"
                  [(ngModel)]="connectionAddressData.residential_unit_no"
                  name="apartmentNumber"
                  #apartmentNumber="ngModel"
                  [disabled]="!connectionAddressSection.isDataEditable" />
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"></div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'personal-data.form-details.fields.floor-number' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  pInputText
                  maxlength="30"
                  size="30"
                  [(ngModel)]="connectionAddressData.floor"
                  name="floor"
                  #floor="ngModel"
                  [disabled]="!connectionAddressSection.isDataEditable" />
              </div>
            </div>
          </div>
          <div *ngIf="useAreaLocation">
            <div
              *ngFor="let location of areaLocations; index as i; trackBy: areaLocationsTrackBy"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div *ngIf="!useDropdownForArea" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required">{{ 'grid-comp.area' | translate }}</label>
                <input
                  class="ui-input pInputText"
                  pInputText
                  size="30"
                  [(ngModel)]="location.area"
                  name="area{{ i }}"
                  #area{{i}}="ngModel"
                  required
                  [disabled]="!connectionAddressSection.isDataEditable" />
              </div>
              <div *ngIf="useDropdownForArea" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required">{{ 'grid-comp.area' | translate }}</label>
                <p-dropdown
                  [options]="areaOptions"
                  optionLabel="area"
                  dataKey="area"
                  [filter]="true"
                  placeholder="-Select-"
                  (onChange)="selectArea($event.value, i)"
                  [disabled]="!connectionAddressSection.isDataEditable"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="location.areaOption"></p-dropdown>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
                <label class="ui-g-5 field-label text-right-align required">{{ 'grid-comp.field' | translate }}</label>
                <input
                  class="ui-input pInputText"
                  maxlength="100"
                  pInputText
                  size="30"
                  [(ngModel)]="location.field"
                  name="field{{ i }}"
                  #field{{i}}="ngModel"
                  required
                  [disabled]="!connectionAddressSection.isDataEditable" />
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
                <label class="ui-g-5 field-label text-right-align required">{{ 'grid-comp.field-sector' | translate }}</label>
                <input
                  class="ui-input pInputText"
                  maxlength="100"
                  pInputText
                  size="30"
                  [(ngModel)]="location.field_sector"
                  name="field_sector{{ i }}"
                  #field_sector{{i}}="ngModel"
                  required
                  [disabled]="!connectionAddressSection.isDataEditable" />
              </div>
              <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
                <div
                  *ngIf="i > 0"
                  (click)="removeLocation(location)"
                  class="pi pi-trash pointer-cursor right-aligned ui-g-2"
                  [ngClass]="!connectionAddressSection.isDataEditable ? 'disable-section' : ''"></div>
              </div>
            </div>
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <div class="ui-g-12 add-button-row" [ngClass]="!connectionAddressSection.isDataEditable ? 'disable-section' : ''">
                  <div class="empty-container"></div>
                  <i (click)="addLocation()" class="pi pi-plus plus-icon" tabindex="0" appEnterClick></i>
                  <label class="ui-g-5 field-label">
                    {{ 'grid-comp.add-area' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-review-section>
      <!-- CONNECTION ADDRESS -->

      <!-- SUBSCRIBER OWNER -->
      <app-review-section
        #subscriberOwnerSection
        [title]="'personal-data.form-details.subscriber-title' | translate"
        [tooltip]="'tooltips.personal-data.subscriber' | translate"
        [sectionId]="SectionIdentifier.PersonalData_Subscriber"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div [ngClass]="personalDataSectionsState?.is_subscriber_owner_locked !== true || !isDetailsView ? '' : 'disable-section'">
          <div
            *ngIf="!useAreaLocation && !isDetailsView"
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows checkbox-row">
              <label class="ui-g-5"></label>
              <p-checkbox
                appEnterClick
                (onChange)="assignAddress(subscriberAddress)"
                binary="true"
                [(ngModel)]="subscriberAddress.is_address_assigned"
                name="subIsAddressAssigned"
                #subIsAddressAssigned="ngModel"
                label="{{ 'personal-data.form-details.fields.info-checkbox' | translate }}"
                [disabled]="!subscriberOwnerSection.isDataEditable"></p-checkbox>
            </div>
          </div>

          <app-person-data-fields
            [personData]="subscriberAddress"
            [formName]="formNames.subscriberForm"
            [hasEmail]="true"
            [isDetailsView]="isDetailsView"
            [isDisabled]="!subscriberOwnerSection.isDataEditable"
            [appNotFinished]="applicationNotFinished"
            (formChangedEvent)="formStateChanged($event)"></app-person-data-fields>

          <div class="personal-data-container component-container">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows margin-align">
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-9 field-label text-right-align">{{ 'grid-comp.grid-comp-landlord' | translate }}</label>
                <p-inputSwitch
                  appEnterClick
                  [(ngModel)]="subscriberAddress.owner_is_landlord"
                  name="ownerIsLandlord"
                  binary="true"
                  #ownerIsLandlord="ngModel"
                  [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
                  [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
                  [disabled]="!subscriberOwnerSection.isDataEditable"></p-inputSwitch>
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-9 field-label text-right-align">{{ 'grid-comp.grid-comp-pp-operator' | translate }}</label>
                <p-inputSwitch
                  appEnterClick
                  [(ngModel)]="subscriberAddress.owner_is_pp_operator"
                  (ngModelChange)="operatorSwitchChanged($event)"
                  name="ownerIsPpOperator"
                  binary="true"
                  #ownerIsPpOperator="ngModel"
                  [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
                  [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
                  [disabled]="!subscriberOwnerSection.isDataEditable"></p-inputSwitch>
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-9 field-label text-right-align">{{ 'grid-comp.grid-comp-recipient' | translate }}</label>
                <p-inputSwitch
                  appEnterClick
                  [(ngModel)]="subscriberAddress.owner_is_invoice_recepient"
                  (ngModelChange)="invoiceSwitchChanged($event)"
                  name="ownerIsInvoiceRecepient"
                  binary="true"
                  #ownerIsInvoiceRecepient="ngModel"
                  [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
                  [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
                  [disabled]="!subscriberOwnerSection.isDataEditable"></p-inputSwitch>
              </div>
            </div>
            <div
              *ngIf="!subscriberAddress.owner_is_landlord"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column section-field margin-align">
              <label class="ui-g-2 field-label text-right-align required">
                {{ 'grid-comp.landlord-power-of-attorney' | translate }}
              </label>
              <app-file-upload
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
                [fileData]="subscriberAddress.power_of_attorney"
                [inputName]="'power_of_attorney'"
                [isDetailsView]="
                  (isDetailsView && subscriberAddress.power_of_attorney?.filename) || isModeratorRole() || role === 'observer'
                "
                [isClearButtonDisabled]="!subscriberOwnerSection.isDataEditable"
                [type]="documentTypes.PowerOfAttorney"
                [isRequired]="!isModeratorRole()"
                (clearFileEvent)="clearFile($event)"></app-file-upload>
            </div>
          </div>
        </div>
      </app-review-section>
      <!-- SUBSCRIBER OWNER -->

      <!-- INVOICE ADDRESS -->
      <app-review-section
        #invoiceAddressSection
        *ngIf="!subscriberAddress.owner_is_invoice_recepient"
        [title]="'personal-data.form-details.invoice-address-title' | translate"
        [tooltip]="'tooltips.personal-data.grid.invoice-address' | translate"
        [sectionId]="SectionIdentifier.PersonalData_InvoiceAddress"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div [ngClass]="personalDataSectionsState?.is_invoice_address_locked !== true || !isDetailsView ? '' : 'disable-section'">
          <app-person-data-fields
            [personData]="invoiceAddress"
            [formName]="formNames.invoiceForm"
            [isDetailsView]="isDetailsView"
            [isDisabled]="!invoiceAddressSection.isDataEditable"
            (formChangedEvent)="formStateChanged($event)"></app-person-data-fields>
        </div>
      </app-review-section>
      <!-- INVOICE ADDRESS -->

      <!-- POWER PLANT OPERATOR -->
      <app-review-section
        #operatorOfPowerPlantSection
        *ngIf="!subscriberAddress.owner_is_pp_operator"
        [title]="'grid-comp.power-plant-operator' | translate"
        [tooltip]="'tooltips.personal-data.power-plant-operator' | translate"
        [sectionId]="SectionIdentifier.PersonalData_PowerPlantOperator"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div [ngClass]="personalDataSectionsState?.is_operator_of_power_plant_locked !== true || !isDetailsView ? '' : 'disable-section'">
          <app-person-data-fields
            [personData]="operatorPpAddress"
            [hasEmail]="true"
            [hasCompany]="true"
            [isDetailsView]="isDetailsView"
            [isDisabled]="!operatorOfPowerPlantSection.isDataEditable"
            [appNotFinished]="applicationNotFinished"
            [formName]="formNames.operatorForm"
            (formChangedEvent)="formStateChanged($event)"></app-person-data-fields>
        </div>
      </app-review-section>
      <!-- POWER PLANT OPERATOR -->

      <!-- TECHNICIAN INFO -->
      <div *ngIf="isDetailsView" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-technician-info
          [isReadOnly]="true"
          [technicianData]="technicianData"
          [applicationId]="applicationId"
          [isDetailsView]="isDetailsView"></app-technician-info>
      </div>
      <!-- TECHNICIAN INFO -->

      <!-- COMPANY DATA INFO -->
      <app-review-section
        #companyDataInfoSection
        *ngIf="isDetailsView"
        [title]="'personal-data.form-details.responsible-installer-title' | translate"
        [tooltip]="'tooltips.personal-data.responsible-installer' | translate"
        [sectionId]="SectionIdentifier.PersonalData_ResponsibleInstaller"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
          <app-company-data [companyDataFG]="companyDataFG" [isReadOnly]="true"></app-company-data>
        </div>
      </app-review-section>
      <!-- COMPANY DATA INFO -->

      <app-order-history
        *ngIf="showOrderHistory && isDetailsView"
        [applicationId]="applicationId"
        [pagination]="true"
        (formChange)="historyLogForm = $event"></app-order-history>

      <div class="ui-g-12 submit-button-section" *ngIf="showButtons">
        <button
          *ngIf="isDetailsView"
          type="button"
          class="ui-button mr-3"
          (click)="previousPage()"
          label="{{ 'grid-comp.back' | translate | uppercase }}"
          pButton></button>
        <button
          *ngIf="isDetailsView"
          type="button"
          class="ui-button-save mr-3"
          [disabled]="!formsValid || !(personalDataForm.dirty || formDirty || isLockUnlockButtonClicked)"
          (click)="saveFormData(false)"
          label="{{ 'grid-comp.save' | translate | uppercase }}"
          pButton></button>
        <button
          type="button"
          class="ui-button-proceed"
          [disabled]="!formsValid"
          (click)="saveFormData(true)"
          label="{{ 'grid-comp.proceed' | translate | uppercase }}"
          pButton></button>
      </div>
    </form>
  </ng-container>
</div>

<app-loader *ngIf="isLoading"></app-loader>
